module.exports = __webpack_public_path__ + "static/image1991-54fc6fcfebc30ce2db596f0fc34e6073.jpeg";